import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_URL } from '../data/offer';
export function CtaBox() {
  return <aside aria-label="Ver el método" className="my-10" data-id="element-141" data-mp="1maku2r20mbnl">
      <a href={OFFER_URL} className="group flex w-full items-center justify-center gap-2.5 rounded-md bg-brand px-5 py-4 text-center font-sans text-base font-bold text-white shadow-sm transition-colors duration-150 ease-out hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-dark focus-visible:ring-offset-2 sm:text-lg" data-id="element-142" data-mp="18imsr2ejpk1z">
        <span data-id="element-143" data-mp="256ax8hlope32">Toca aquí para verlo</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-144" data-mp="1r9nrpqfo1flj" />
      </a>
      <p className="mt-3 text-center font-sans text-xs text-ink-muted" data-id="element-145" data-mp="ft63gdm82j9z">
        Guía digital · Acceso inmediato · Resultados individuales pueden variar
      </p>
    </aside>;
}